import errorMessage from "../helper/ErrorMessage";

const SignedRequest = async (
    values,
    keyCallbacks,
    form,
    dataUrl,
    signedUrl,
    popupAlert,
    setLoading,
    wrapContent
) => {
    try {
        const resp1 = await fetch(
            dataUrl,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                    'X-Session': localStorage.getItem('session')
                },
                body: JSON.stringify(values)
            }
        );

        if (resp1.status === 200) {
            const data = await resp1.json();
            let id = data.id;
            keyCallbacks.sign(
                wrapContent ? data.content : JSON.stringify(data),
                form,
                async (signed) => {
                    try {
                        const resp2 = await fetch(
                            signedUrl,
                            {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                                    'X-Session': localStorage.getItem('session')
                                },
                                body: wrapContent ? JSON.stringify({content: signed.base64Data, id: id}) : signed.base64Data
                            }
                        );

                        const data = await resp2.json();

                        if (data.success) {
                            popupAlert('Запит успішно відправлений.');
                        } else {
                            errorMessage(data, popupAlert);
                        }
                        setLoading(false);
                    } catch (e) {
                        popupAlert('Помилка надсилання запиту');
                        setLoading(false);
                    }
                }
            );
        } else {
            const data = await resp1.json();
            popupAlert(data.error || 'Помилка надсилання запиту');
            setLoading(false);
        }
    } catch (e) {
        popupAlert('Помилка надсилання запиту');
        setLoading(false);
    }
}

export default SignedRequest;